const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: `Which of the following statements are correct?
    (a) Unicorns are startups valued at over one billion US dollars.
    (b) The Reserve Bank of India is the regulator of the insurance sector in India.
    (c) GST in India follows a dual structure comprising CGST and SGST.
    (d) Zomato and Swiggy are among India's largest online food delivery platforms.`,
    options: ["A. (a), (b), (c) and (d)", "B. (a), (b) and (c)", "C. (b), (c) and (d)", "D. (a), (c) and (d)"],
    answer: "D"
  },
  {
    id: 72,
    question: `With reference to health indicators, consider the following statements.
    (a) Maternal Mortality Ratio (MMR) is expressed per 1,00,000 live births.
    (b) Infant Mortality Rate (IMR) is the number of infant deaths per 1000 live births.
    (c) Life expectancy indicates the average age at death of the current population.
    Which of the statements given above is/are correct?`,
    options: ["A. (b) and (c)", "B. (a) and (c)", "C. (a) and (b)", "D. (a), (b) and (c)"],
    answer: "C"
  },
  {
    id: 73,
    question: `Consider the following statements and select the correct answer using the codes given below.
    (i) Equity shares represent ownership in a company.
    (ii) Debentures are a form of equity capital.
    (iii) Preference shares carry a fixed rate of dividend.
    (iv) The Reserve Bank of India can lend directly to individual citizens.`,
    options: ["A. Only (i) is correct", "B. (i), (ii), (iii) and (iv) are correct", "C. (ii) and (iv) are correct", "D. (i) and (iii) are correct"],
    answer: "D"
  },
  {
    id: 74,
    question: `Match the following heads of various financial institutions in List-I with their designations in List-II.
    List-I: (a) Governor of RBI  (b) Chairperson of SEBI  (c) Finance Secretary of India  (d) NITI Aayog CEO
    List-II: (i) Regulates capital markets  (ii) Heads the central bank  (iii) Coordinates finance ministry departments  (iv) Heads the government think tank`,
    options: ["A. a-i, b-ii, c-iv, d-iii", "B. a-ii, b-i, c-iii, d-iv", "C. a-iii, b-iv, c-ii, d-i", "D. a-iv, b-iii, c-i, d-ii"],
    answer: "B"
  },
  {
    id: 75,
    question: "An economy experiences a sustained decline in agriculture's share of output accompanied by growth in the services sector and rising urbanisation. This situation most appropriately indicates",
    options: ["A. Structural transformation of the economy", "B. Cyclical fluctuations in economic activity", "C. A short-term liquidity crisis", "D. Contraction of the informal sector"],
    answer: "A"
  },
  {
    id: 76,
    question: `Match the following.
    List-I (Transportation mode): (a) Pipeline transport  (b) Road transport  (c) Rail transport  (d) Air transport
    List-II (Characteristics): (i) High flexibility and last-mile connectivity  (ii) Fastest mode for long-distance passenger travel  (iii) Economical for continuous bulk transport of liquids and gases  (iv) Economies of scale for bulk freight over land`,
    options: ["A. a-iii, b-i, c-iv, d-ii", "B. a-i, b-ii, c-iii, d-iv", "C. a-iv, b-iii, c-i, d-ii", "D. a-ii, b-iv, c-i, d-iii"],
    answer: "A"
  },
  {
    id: 77,
    question: `Match the List-I (concepts) with List-II (explanation) on entrepreneurial finance.
    List-I: (a) Seed funding  (b) Bootstrapping  (c) Venture capital  (d) Crowdfunding
    List-II: (i) Raising small amounts from a large number of people  (ii) Self-financing in the early stage of a business  (iii) Early-stage external investment for a new idea  (iv) Professional investment for high-growth companies`,
    options: ["A. a-i, b-iv, c-ii, d-iii", "B. a-ii, b-iii, c-i, d-iv", "C. a-iii, b-ii, c-iv, d-i", "D. a-iv, b-i, c-iii, d-ii"],
    answer: "C"
  },
  {
    id: 78,
    question: "In a standard e-commerce business model, what is the correct sequence of an order's journey after purchase?",
    options: ["A. Warehouse → Order placed → Last-mile delivery → Sorting centre", "B. Last-mile delivery → Warehouse → Sorting centre → Order placed", "C. Sorting centre → Order placed → Warehouse → Last-mile delivery", "D. Order placed → Warehouse picking → Sorting centre → Last-mile delivery"],
    answer: "D"
  },
  {
    id: 79,
    question: `Which of the following statements about the business-to-consumer (B2C) e-business model are correct?
    (a) It involves transactions directly between a business and an individual customer.
    (b) Amazon and Flipkart are examples of B2C platforms.
    (c) It eliminates any need for logistics or delivery infrastructure.
    (d) OLX primarily operates as a B2C platform.`,
    options: ["A. (a), (b) and (c)", "B. (a) and (b) only", "C. (b), (c) and (d)", "D. (c) and (d) only"],
    answer: "B"
  },
  {
    id: 80,
    question: `Which of the following statements about Government of India initiatives to promote entrepreneurship under the Startup India scheme are correct?
    (a) It offers tax exemptions to eligible startups for a specified period.
    (b) It provides financial support only to companies older than ten years.
    (c) It facilitates easier compliance through self-certification.
    (d) DPIIT recognition is required to access most Startup India benefits.`,
    options: ["A. (a), (c) and (d) only", "B. (a) and (b) only", "C. (b) and (c) only", "D. (b) and (d) only"],
    answer: "A"
  },
  {
    id: 81,
    question: "In which of the two separate fields had Marie Curie won the Nobel Prize?",
    options: ["A. Physics and Peace", "B. Physics and Chemistry", "C. Chemistry and Medicine", "D. Peace and Medicine"],
    answer: "B"
  },
  {
    id: 82,
    question: "The process of conversion of a liquid directly into a gas below its boiling point is called",
    options: ["A. Condensation", "B. Sublimation", "C. Evaporation", "D. Fusion"],
    answer: "C"
  },
  {
    id: 83,
    question: `Consider the following statements and select the correct answer using the codes given below.
    (I) Secondary market deals with the trading of already-issued securities.
    (II) Capital market is a market for short-term transactions.
    (III) SEBI was established as a statutory regulatory body under the SEBI Act in the year 1988.
    (IV) Money market is a market for long-term transactions.`,
    options: ["A. (I) and (III) are correct", "B. (I) is correct only", "C. (I), (II), (III) and (IV) are correct", "D. (II) and (IV) are correct"],
    answer: "B"
  },
  {
    id: 84,
    question: `Match the e-governance project with the sector it primarily serves.
    List-I (Project Name): (a) Bhoomi  (b) DigiLocker  (c) e-NAM  (d) Ayushman Bharat Digital Mission
    List-II (Sector): (i) Digital document storage  (ii) Agricultural trading  (iii) Land records  (iv) Healthcare`,
    options: ["A. a-iv, b-iii, c-i, d-ii", "B. a-i, b-ii, c-iii, d-iv", "C. a-iii, b-i, c-ii, d-iv", "D. a-ii, b-iv, c-i, d-iii"],
    answer: "C"
  },
  {
    id: 85,
    question: `Consider the following statements.
    Statement-I: India's public sector healthcare system largely focuses on curative rather than preventive care.
    Statement-II: Under India's federal structure, health is primarily a state subject.
    Which of the following is correct in respect of the above statements?`,
    options: ["A. Statement-I is incorrect but Statement-II is correct", "B. Both are correct but Statement-II does not explain Statement-I", "C. Statement-I is correct but Statement-II is incorrect", "D. Both Statement-I and Statement-II are correct, and Statement-II is the correct explanation for Statement-I"],
    answer: "B"
  },
  {
    id: 86,
    question: "When traditional customs and beliefs persist even after the material conditions of society have rapidly changed, this situation is called",
    options: ["A. Cultural diffusion", "B. Cultural lag", "C. Cultural assimilation", "D. Cultural relativism"],
    answer: "B"
  },
  {
    id: 87,
    question: "Which of the following is NOT typically considered a function of business correspondence?",
    options: ["A. Creating a cordial business atmosphere", "B. Providing contact and reference", "C. Personal socialising unrelated to business", "D. Promoting sales"],
    answer: "C"
  },
  {
    id: 88,
    question: "Which technology is commonly used in modern smartphones for contactless payments?",
    options: ["A. Near Field Communication (NFC)", "B. Radio Frequency Identification for vehicle tracking", "C. Light Detection and Ranging (LiDAR)", "D. Global Positioning System (GPS) only"],
    answer: "A"
  },
  {
    id: 89,
    question: "The accidental death and disability coverage under the Pradhan Mantri Suraksha Bima Yojana (PMSBY) is",
    options: ["A. Rs. One Lakh", "B. Rs. Two Lakhs", "C. Rs. Three Lakhs", "D. Rs. Five Lakhs"],
    answer: "B"
  },
  {
    id: 90,
    question: `Which of the following are considered crucial for businesses to navigate uncertain economic conditions and market disruptions?
    (a) Diversifying revenue streams
    (b) Maintaining a rigid organisational structure
    (c) Proactively monitoring market trends
    d) Reducing unnecessary operating expenses`,
    options: ["A. (a), (c) and (d)", "B. (a), (b), (c) and (d)", "C. (b) and (c) only", "D. (a) and (b) only"],
    answer: "A"
  }
  
];
 
export default pgcetmcaGeneralAwareness;